import { INCREASE_PAGE }  from 'reducers/PlaylistReducer'

export const increasePage = () => {
  return {
    type: INCREASE_PAGE,
  }
}



// WEBPACK FOOTER //
// ./src/actions/PlaylistActions.js